import React, {FC} from "react"

import {WellnessMediaArticle} from "@irati/types"
import Flex from "@irati/ui/src/Flex"
import {H4, Label} from "@irati/ui/src/Typography"
import mainTheme from "@irati/ui/src/global/theme"
import {FormattedMessage} from "@irati/utils/lang"
import Pill from "@irati/ui/src/Pill"
import {upcomingEventDateAndTime, videoInProgress} from "@irati/wellness/utils"
import MediaImportantTags from "../MediaImportantTags"
import LiveVideoCardLabelNotificationState from "./LiveVideoCardLabelNotificationState"

import {TopDetailsLiveVideoContainer, BottomDetailsLiveVideoContainer, StyledLabel, Image} from "./styled"

interface Props {
  media: WellnessMediaArticle,
  wellnessNotificationIdsList: string[]
}

const LiveVideoCardDetails: FC<Props> = ({media, wellnessNotificationIdsList}) => {
  const inProgress = videoInProgress(media.liveVideoStartTime, media.liveVideoEndTime)

  return (
    <Flex justifyContent="space-between" direction="column" height="100%">
      <TopDetailsLiveVideoContainer justifyContent="space-between" alignItems="center">
        <Label color="white">{upcomingEventDateAndTime(media.liveVideoStartTime, media.liveVideoEndTime)}</Label>
        {inProgress && (
          <Pill
            text={<FormattedMessage id="wellness.liveVideoCard.live" />}
            backgroundColor={mainTheme.colors.tertiary.r_400}
            isWhiteText
            color={mainTheme.colors.greys.white} />
        )}
      </TopDetailsLiveVideoContainer>

      <Flex alignItems="center" justifyContent="space-between" marginTop={1}>
        <H4 color="white">{media.title}</H4>
        {media.author.image && <Image src={media.author.image} />}
      </Flex>

      <BottomDetailsLiveVideoContainer direction="column">
        <MediaImportantTags media={media} color={mainTheme.colors.utility.white} />
        {inProgress ? (
          <StyledLabel marginTop={2} inProgress={inProgress}>
            <FormattedMessage id="wellness.liveVideoCard.videoInProgress.ctaText" />
          </StyledLabel>
        ) : (
          <LiveVideoCardLabelNotificationState media={media} wellnessNotificationIdsList={wellnessNotificationIdsList} />
        )}
      </BottomDetailsLiveVideoContainer>
    </Flex>
  )
}

export default LiveVideoCardDetails
